import styled, { css } from 'styled-components';
import { default as InlineSvg } from 'react-inlinesvg';
export var StyledInlineSvg = styled(InlineSvg).withConfig({
  displayName: "styles__StyledInlineSvg",
  componentId: "sc-ijha6n-0"
})(["flex-shrink:0;", ";"], function (props) {
  return props.$shouldAdjustBoundingWhitespace ? css(["overflow:visible;> *{transform:scale(1.5);transform-origin:center;}"]) : undefined;
});